import React from "react";

import Navbar from "../Components/Navbar";
import img from "../assets/Legend.png"
// import Footer from "../Components/Footer";
import { Toaster } from "react-hot-toast";
import Options from "../Components/Options";
import Header from "../Components/Header";
import Maps from "../Components/map/Maps";
function Home(props) {
  return (

    <div className="h-screen flex flex-col ">
      <div className="w-full h-full flex flex-col ">
        <Navbar />
        <Toaster position="top-center" reverseOrder={false} />
        <Header />
        {/* {true === 'Infestation Prediction Alert'  && <AlertOptions/>} */}
        {/* {true !== 'Infestation Prediction Alert'  && <Options/>} */}
        <Options />
        <Maps />

        <div  className="py-0.5 flex justify-center" >

          <img  width={'40%'} src={img} alt="" />
        </div>
      </div>

      {/* <Footer/> */}
      <p  className="text-center text-xs font-bold">
      Powered by NIRUTHI ©
      </p>

    </div>
  );
}

export default Home;
